import React from 'react'

import Details from './Details'

const BusinessesTabs = ({
  tab,
  business,
  profile,
  handleClick,
  onPublishToggle,
  onFeatureToggle,
  handleDeleteDialogOpen,
  handleUpgradeDialogClick,
  userId,
}) => {
  const tabs = [
    business ? (
      <Details
        business={business}
        userId={userId}
        profile={profile}
        handleClick={handleClick}
        onPublishToggle={onPublishToggle}
        onFeatureToggle={onFeatureToggle}
        handleDeleteDialogOpen={handleDeleteDialogOpen}
        handleUpgradeDialogClick={handleUpgradeDialogClick}
      />
    ) : null,
  ]

  return tabs[tab]
}

export default BusinessesTabs



// WEBPACK FOOTER //
// ./src/components/account/businesses/Businesses/Panel/Tabs/index.js